// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__DJRMK","title":"styles_title__1ogJp","label":"styles_label__XHApa","btnGridItem":"styles_btnGridItem__2r6C8","proceedBtn":"styles_proceedBtn__TrbPi"};